module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-interactive-product-instructions-400x284-e65d4e608918eb4eb8eead497cea9a68.jpg";